export default __webpack_public_path__ + "static/media/Dodge.4450b9d2.svg";